import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import CardDeatils from '../../../atoms/Card/CardDeatils';
const OfferAndPromocodes =()=>{
    return(
        <>
          <section className='popular-section section-padding'>
            <Container >
                <Row className='mb-4'>
                    <Col className="col-12 col-md-12 text-center">
                        <h2 className='promocode-section--h2 h2'>Cars for your every need</h2>
                    </Col>
                </Row>
                <CardDeatils />
            </Container>
          </section>
        </>
    )
}
export default OfferAndPromocodes